import { classSet } from "@/javascript/lib/helpers.js";
import i18n from "@/javascript/lib/i18n.js";
import styles from "./spinner.module.css";

export function Spinner({
  size = "medium",
  className,
  "aria-hidden": ariaHidden,
}: SpinnerProps) {
  return (
    <div
      className={classSet(styles.spinner, className)}
      data-size={size}
      role="status"
      aria-hidden={ariaHidden}
    >
      <span className="visually-hidden">
        {i18n.t("js.components.puts.spinner.loading")}
      </span>
    </div>
  );
}

export type SpinnerProps = {
  size?: "small" | "medium" | "large";
  className?: string;
  "aria-hidden"?: boolean;
};
